import Image from "next/image";
import styles from "./Header.module.scss";

export const Header = function () {
  return (
    <div className={styles.headerImage}>
      <Image
        src="https://www.getsmarter.com/presentations/wp-content/uploads/2020/01/MITSLOAN-CSAIL-onlight-01.png"
        alt="university logo"
        width={227}
        height={80}
      />
    </div>
  );
};
